import { React } from 'imports';
import './ScrollTable.less';

// a placeholder for AgGrid based diagram component
// currently it's just checks and exposes AgGrid DLL

// we can not use 'import' here since webpack tries to evaluate all imported modules as soon as current module is imported somewhere
// highcharts are loaded as DLL dynamically
// 'require'd modules however are evaluated only when 'require' is call, so it allows us to evaluate when needed
// usually it means all DLL dependencies are ensured

const AG_GRID_LICENSE_KEY = 'CompanyName=4Straction Ltd,LicensedApplication=4Straction,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-012635,ExpiryDate=30_December_2021_[v2]_MTY0MDgyMjQwMDAwMA==78d8ae9864b953fa8a61676aad29cf79';
let AgGrid: any | null = null,
    AgChart: any | null = null;

function loadAgGrid() {
    if (typeof DLL_PATHS !== 'undefined' && !(window as any).aggrid) {
        throw new Error('aggrid DLL has to be loaded before using ScrollTable.');
    }

    AgGrid = require('ag-grid-enterprise/dist/ag-grid-enterprise.min.js');
    AgGrid.LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY);

    return AgGrid;
}

function loadAgChart() {
    if (typeof DLL_PATHS !== 'undefined' && !(window as any).aggrid) {
        throw new Error('aggrid DLL has to be loaded before using ScrollTable.');
    }

    AgChart = require('ag-charts-community/dist/ag-charts-community.min.js');
    return AgChart;
}

export default class ScrollTable extends React.PureComponent {
    static get Grid() {
        return (AgGrid || loadAgGrid()).Grid;
    }

    static get Chart() {
        return (AgChart || loadAgChart()).AgChart;
    }

    render() {
        // TODO implement some static config and reconciliation stuff similar to Chart component
        return null;
    }
}
